export function emblaListingSchemaEnhancer(schema, formData = {}, intl) {
  const useListing = !!formData?.useListing;

  // Work on the Content fieldset (id: 'default')
  const contentFieldset = schema?.fieldsets?.find((fs) => fs.id === 'default');
  const fields = contentFieldset?.fields || [];

  // Fields that must always exist in the Content fieldset
  const baseMustHave = [
    'title',
    'description',
    'useListing',
    'filterTags',
  ];

  baseMustHave.forEach((f) => {
    if (!fields.includes(f)) fields.push(f);
  });

  // Fields that must exist in other fieldsets — just ensure properties exist
  const otherFields = [
    'displayMode',
    'dateDisplay',
    'hideDescription',
    'hideButtons',
    'clickableSlides',
    'equalHeight',
    'slidesToShow',
    'minSlidesOnMobile',
    'centeredPeek',
    'loop',
    'autoplay',
    'autoplayDelay',
    'arrowPosition',
    'headerLinkText',
    'headerLinkUrl',
    'hideArrows',
    'hideDots',
    'alignment',
    'isFullWidth',
    'backgroundColor',
    'textTone',
    'outerClassName',
  ];
  // (properties for these are defined in schema-base; nothing to inject)

  // Ensure useListing property exists
  schema.properties = schema.properties || {};
  if (!schema.properties.useListing) {
    schema.properties.useListing = {
      title: 'Use content query',
      description: 'Pull slides automatically from a content query instead of adding them manually',
      type: 'boolean',
      default: false,
    };
  }

  // Listing-specific fields
  const listingFields = ['query', 'appendManualSlides', 'listingButtonText', 'listingButtonStyle'];

  if (useListing) {
    // Inject listing fields into Content fieldset if not already there
    listingFields.forEach((f) => {
      if (!fields.includes(f)) {
        // Insert after 'useListing'
        const idx = fields.indexOf('useListing');
        fields.splice(idx + 1, 0, f);
      }
    });

    schema.properties.query = schema.properties.query || {
      title: 'Content query',
      widget: 'query',
    };
    schema.properties.appendManualSlides = schema.properties.appendManualSlides || {
      title: 'Also show manual slides',
      description: 'Append any manually added slides after the query results',
      type: 'boolean',
      default: false,
    };
    schema.properties.listingButtonText = schema.properties.listingButtonText || {
      title: 'Button text',
      description: 'Label for the "Read more" button on each result',
      type: 'string',
      default: 'Read more',
    };

    // Show slides field only if appendManualSlides is on
    if (formData?.appendManualSlides) {
      if (!fields.includes('slides')) fields.push('slides');
    } else {
      const idx = fields.indexOf('slides');
      if (idx !== -1) fields.splice(idx, 1);
    }
  } else {
    // Remove listing-only fields
    listingFields.forEach((f) => {
      const idx = fields.indexOf(f);
      if (idx !== -1) fields.splice(idx, 1);
    });

    // Ensure manual slides field is present
    if (!fields.includes('slides')) {
      const idx = fields.indexOf('useListing');
      fields.splice(idx + 1, 0, 'slides');
    }
  }

  return schema;
}
